import { PageLoadingIndicator } from '@wrisk/ui-components'
import React, { FunctionComponent } from 'react'
import { Navigate } from 'react-router'

import { useApiErrorHandlingAsync } from '../../../../../hooks/auth'
import { usePrincipal } from '../../../../authentication'
import { AdjustmentErrorPage } from './AdjustmentErrorPage'
import { AdjustmentSuccessPage } from './AdjustmentSuccessPage'

export interface PolicyAdjustmentResultPageProps {
  adjustmentId: string
  onComplete: () => void
  onRepeat: () => void
}

export const PolicyAdjustmentResultPage: FunctionComponent<
  PolicyAdjustmentResultPageProps
> = ({ adjustmentId, onComplete, onRepeat }) => {
  const { apiClient } = usePrincipal()

  const { result, loading } = useApiErrorHandlingAsync(apiClient.getPolicyAdjustment, [
    adjustmentId,
  ])

  if (loading) return <PageLoadingIndicator />

  return !result ? (
    <Navigate to='..' />
  ) : result.confirmed ? (
    <AdjustmentSuccessPage
      policyAdjustmentResponse={result}
      onRepeat={onRepeat}
      onComplete={onComplete}
    />
  ) : (
    <AdjustmentErrorPage
      verificationClear={result.verificationClear}
      onComplete={onComplete}
    />
  )
}
